import { cn } from '@/lib/cn';
import { Eye, EyeOff } from 'lucide-react';
import { type InputHTMLAttributes, forwardRef, useState } from 'react';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

export const PasswordInput = forwardRef<HTMLInputElement, Props>(({ className, ...props }, ref) => {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={shown ? 'text' : 'password'}
        className={cn(
          'h-10 w-full rounded-md border border-border bg-surface pl-3 pr-10 text-sm text-foreground',
          'placeholder:text-foreground-muted',
          'focus-visible:outline-none',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          className,
        )}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShown((v) => !v)}
        aria-label={shown ? '비밀번호 숨기기' : '비밀번호 표시'}
        className="absolute right-1 top-1/2 -translate-y-1/2 size-8 grid place-items-center rounded-md text-foreground-muted hover:bg-surface-muted hover:text-foreground"
        tabIndex={-1}
      >
        {shown ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = 'PasswordInput';
